import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    copied: 'Link copied',
    copyLink: 'Copy link',
  },
  fr: {
    copied: 'Lien copié',
    copyLink: 'Copier le lien',
  },
} as const);

export default locales;
